import { Breadcrumb, Card, EventHandler, Row, SwitchToggle } from "client/CommonComponents"
import '../AcquisitionCodeMaintenanceListing/AcquisitionCodeMaintenanceListing.scss';
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup";
import permissions, { isAuthorized } from "client/utils/Permissions";

const
    DispositionPenaltyFlag = ({
        breadcrumlist,
        handleClickBack,
        globalPenaltyFlag,
        onFlagChange,
        Popupcontent,
        hideDialog }: any) => {
        return (
            <>
                <div className='breadCrumbBlock'>
                <EventHandler onEvent={handleClickBack} data-attribute="DispositionPenaltyFlag_Default_EventHandler">
                    <div className='backButton mb-sm-2 mb-3'>
                        <span className="fa fa-chevron-left"></span>
                        Back
                    </div>
                </EventHandler>
                    <div className='breadcrumbList'>
                        <Breadcrumb items={breadcrumlist} maxDisplayedItems="5"  data-attribute="DispositionPenaltyFlag_Default_Breadcrumb" />
                    </div>
                </div>
                <Card data-attribute="DispositionPenaltyFlag_Default_Card">
                    <div className='create-new-order-container admin-tab'>
                        <div className='grid-block pt-3 pb-0'>
                            <p className='blueLabel pull-left'>DISPOSITION PENALTY FLAG</p>
                            <div className='mb-1 top-section clearfix'>
                                <p className='pull-left mt-2 subHeader'> Disposition Penalty flag</p>
                            </div>
                            <div className='bottom-section'>
                                <Row className='dispositionPenaltyFlag'>
                                    <SwitchToggle checked = {globalPenaltyFlag ?? false} disabled={!isAuthorized(permissions.Create_Edit_Admin)} onChange={(e?: any, item?: any) =>onFlagChange(e, item)}  data-attribute="DispositionPenaltyFlag_Default_SwitchToggle" />
                                    <label>Disposition Penalty flag</label>
                                </Row>
                            </div>
                        </div>
                    </div>
                </Card>
                <CancelConfirmationPopup
                    hideDialog={!Popupcontent.isDialogVisible}
                    onDismiss={hideDialog}
                    Popupcontent={Popupcontent}
                    popupOutlinebtnOnclick={() => Popupcontent.popupOutlinebtnOnclick()}
                    popupPrimarybtnOnclick={() => Popupcontent.popupPrimarybtnOnclick()}
                />
            </>
        )
    }

export default DispositionPenaltyFlag;
